import { useQuery } from "@tanstack/react-query";
import { customerPageKeys, getHubOverview } from "./tool-hubs-api";

export function useHubOverview(organizationId: string, enabled: boolean) {
  return useQuery({
    queryKey: customerPageKeys.overview(organizationId),
    queryFn: () => getHubOverview(organizationId),
    enabled,
  });
}
